export default class UserProfile{
    constructor(
        public customer_ID:number,
        public UserId:string,
        public AgenteID:string,
        public UserName:string,
        public CompanyName:string,
        public CompanyAddress:string,
        public ERPCompanyCode:string,
        public ProtectionLevel:number,
        public ProductCode:string,
        public Roles:string
        )
        {}
    }